import { useEffect } from 'react'
import { useAuthContext } from '../../../../state/useAuth'
import { apiClient } from '../../../../api/apiClient'
import { setAuthorizationHeader } from '../utils'

export const useRequestInterceptor = () => {
  const { authData, refreshAccessToken, isAuthInitialized } = useAuthContext()

  useEffect(
    () => {
      const interceptor = apiClient.interceptors.request.use(
        async (config) => {
          if (!config.headers || !isAuthInitialized) return config

          let accessToken = authData?.access_token
          if (accessToken) {
            accessToken = await refreshAccessToken(30).catch(() => accessToken)
          }

          if (accessToken) {
            setAuthorizationHeader(config, accessToken)
          }

          return config
        },
        (error) => Promise.reject(error)
      )
      return () => apiClient.interceptors.request.eject(interceptor)
    },
    [authData?.access_token, isAuthInitialized, refreshAccessToken]
  )
}
